<template>
    <div class="logo">
        <div class="logo__inner" ref="el">
            <shotcode text="Labyrinth Labyrinth" size="logo" :refresh="true"></shotcode>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Logo',
        data () {
            return {
                el: null,
                mediaQuery: null,
                animationStartTime: Date.now()
            }
        },
        props: {
            fixed: {
                default: false,
                type: Boolean
            },
            breakpoint: {
                default: '(min-width: 600px)',
                type: String
            },
        },
        computed: mapState({
            isLoading: state => state.app.isLoading,
        }),
        watch: {
            isLoading: function (newValue, oldValue) {
                if (newValue == true && oldValue == false) {
                    this.animationStartTime = Date.now();
                    window.requestAnimationFrame(this.animateLoading);
                }
            }
        },
        methods: {
            init() {
                this.mediaQuery = window.matchMedia(this.breakpoint)
                if (this.mediaQuery) {
                    this.mediaQuery.addListener(this.setupListener)
                    this.setupListener()
                }
            },
            animateScroll () {
                let animationValue = window.pageYOffset * 0.15;
                this.animateElement(animationValue);
            },
            animateLoading() {
                let animationValue = window.pageYOffset * 0.15;
                const time = Date.now() - this.animationStartTime;
                this.animateElement(animationValue + time * 0.33);
                if (this.isLoading) {
                    window.requestAnimationFrame(() => {
                        this.animateLoading()
                    });
                }
            },
            animateElement (animationValue) {
                this.el.style.transform = `rotate(${animationValue}deg)`;
            },
            scrollHandler () {
                if (this.isLoading != true) {
                    window.requestAnimationFrame(() => {
                        this.animateScroll();
                    });
                }
            },
            setupListener () {
                if (this.mediaQuery.matches) {
                    window.addEventListener('scroll', this.scrollHandler, false);
                } else {
                    window.removeEventListener('scroll', this.scrollHandler, false);
                }
            }
        },
        mounted() {
            window.requestAnimationFrame = window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (f) {
                setTimeout(f, 1000 / 60)
            };
            this.el = this.$refs.el;
            this.init();

        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.scrollHandler, false)
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Logo.vue